/* jshint esversion: 6 */

import $ from '@/components/js/jquery-vendor';

// var isRTL= false;
var isIE8= false;
var isIE9= false;
var isIE10= false;

var assetsPath= '../assets/';
var globalImgPath= 'global/img/';
var globalPluginsPath=  'global/plugins/';
var globalCssPath= 'global/css/';

// theme layout color set
var brandColors= {
    'blue': '#89C4F4',
    'red': '#F3565D',
    'green': '#1bbc9b',
    'purple': '#9b59b6',
    'grey': '#95a5a6',
    'yellow': '#F8CB00'
};

// initializes main settings
function handleInit () {
  
    if ($('body').css('direction') === 'rtl') {
    //   isRTL = true;
    }

    isIE8 = !!navigator.userAgent.match(/MSIE 8.0/);
    isIE9 = !!navigator.userAgent.match(/MSIE 9.0/);
    isIE10 = !!navigator.userAgent.match(/MSIE 10.0/);

    if (isIE10) {
        $('html').addClass('ie10'); // detect IE10 version
    }

    if (isIE10 || isIE9 || isIE8) {
        $('html').addClass('ie'); // detect IE10 version
    }
}


// To get the correct viewport width based on  http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
    
    //** need this function
function getViewPort() {
      var e = window,
          a = 'inner';
      if (!('innerWidth' in window)) {
          a = 'client';
          e = document.documentElement || document.body;
      }

      return {
          width: e[a + 'Width'],
          height: e[a + 'Height']
      };
  }

  // check IE8 mode
// function isIE8() {
//       return this.isIE8;
//   }

//   // check IE9 mode
// function isIE9() {
//       return this.isIE9;
//   }

  //check RTL mode
//   function  isRTL() {
//       return this.isRTL;
//   }

  // check IE8 mode
  function  isAngularJsApp() {
      return (typeof angular == 'undefined') ? false : true;
  }

  function  getAssetsPath() {
      return assetsPath;
  }

  function setAssetsPath(path) {
      assetsPath = path;
  }

  function setGlobalImgPath(path) {
      globalImgPath = path;
  }

  function getGlobalImgPath() {
      return assetsPath + globalImgPath;
  }

  function setGlobalPluginsPath(path) {
      globalPluginsPath = path;
  }

  function getGlobalPluginsPath() {
      return assetsPath + globalPluginsPath;
  }

  function getGlobalCssPath() {
      return assetsPath + globalCssPath;
  }

  // get layout color code by color name
  function  getBrandColor(name) {
      if (brandColors[name]) {
          return brandColors[name];
      } else {
          return '';
      }
  }

  function getResponsiveBreakpoint(size) {
      // bootstrap responsive breakpoints
      var sizes = {
          'xs' : 480,     // extra small
          'sm' : 768,     // small
          'md' : 992,     // medium
          'lg' : 1200     // large
      };

      return sizes[size] ? sizes[size] : 0; 
  }

  export {
    handleInit, getViewPort, isAngularJsApp, getAssetsPath, setAssetsPath
    ,setGlobalImgPath, getGlobalImgPath, setGlobalPluginsPath, getGlobalPluginsPath
    , getGlobalCssPath, getBrandColor, getResponsiveBreakpoint
};